import React, {PureComponent} from 'react';
import {observer, inject} from 'mobx-react';
import _ from 'lodash';
import validate from 'validate.js';
import HttpClient from 'services/HttpClient';
import {PageWrapper} from 'components/PageWrapper';
import SampleContentForm from '../components/Form';
import {SAMPLE_CONTENT_CONSTRAINS} from 'constants/adminPupups';

const sampleContentUrl = '/api/v1/free_samples';

@inject('sampleContentStore')
@inject('alertStore')
@observer
class AddSampleContent extends PureComponent {
  componentDidMount() {
    const {sampleContentStore} = this.props;
    sampleContentStore.initNewSampleContent();
  }

  handleChange = e => {
    const {sampleContentStore} = this.props;

    if (e.target.name === 'file') {
      sampleContentStore.handleChange({[e.target.name]: e.target.files[0]});
    } else {
      sampleContentStore.handleChange({[e.target.name]: e.target.value});
    }
  };

  validationProcess = sampleContent => {
    let errors = validate(sampleContent, SAMPLE_CONTENT_CONSTRAINS, { fullMessages: false });

    return errors
  };

  submit = e => {
    e.preventDefault();

    const {sampleContentStore} = this.props;
    const sampleContent = _.assign({}, sampleContentStore.sampleContent);
    const errors = this.validationProcess(sampleContent);

    sampleContentStore.setError(errors);
    console.log(errors);

    if (errors) {
      return;
    }

    const formData = new FormData();
    formData.append('title', sampleContent.title);
    formData.append('sample_type', sampleContent.sample_type);

    if (sampleContent.file)
      formData.append('file', sampleContent.file, sampleContent.file.name);

    if (sampleContent.video_url)
      formData.append('video_url', sampleContent.video_url);

    new HttpClient().multipart(sampleContentUrl, formData, 'POST').then(data => {
      sampleContentStore.saveSampleContent(data.body.data.free_sample);
      sampleContentStore.initNewSampleContent();
      this.props.alertStore.success('You successfully created sample content');
      this.props.history.push('/sample-content');
      
    }).catch(() => {
      this.props.alertStore.success('Something went wrong');
      // this.handleUnsuportableEntity(e)
    });
  };

  render() {
    return (
      <PageWrapper>
        <SampleContentForm submit={this.submit} />
      </PageWrapper>
    );
  }
}

export default AddSampleContent;



// WEBPACK FOOTER //
// ./src/modules/admin/sampleContent/containers/Add.js